export default __webpack_public_path__ + "static/media/923.be4030ef.png";